
import { Named } from './named';

export abstract class ChildResourceNamed extends Named {
    public abstract get parentResource(): Named;
}
